export default {
  breadcrumbs: {
    list: 'ユーザ一覧 ',
    register: 'ユーザー登録',
    edit: 'ユーザー変更',
  },
  label: {
    user_type: 'ユーザー区分',
    system: 'システム',
    client: 'クライアント',
    partner_company: '提携企業',
    partner_store: '提携店',
    user_id: 'ユーザーID',
    user_name: 'ユーザー名',
    user_password: 'ユーザーPW',
    email: 'メールアドレス',
    system_select: 'システム選択',
    client_select: 'クライアント選択',
    partner_company_select: '提携企業選択',
    partner_store_select: '提携店選択',
    user_type_select: 'ユーザー区分選択',
    status: 'ステータス',
    start_date: '開始日',
    is_send_invoice_mail: '請求書メール送信',
    is_send_invoice_mail_select: '請求書メール送信選択',
    is_send_report_mail: 'レポート送信',
    is_send_report_mail_select: 'レポート送信選択',
    mail_send: '自動メール送信設定',
  },
  button: {
    register: 'ユーザ一登録',
    generation: '生成',
    select_file: 'ファイルを選択',
  },
  table: {
    user_id: 'ユーザーID',
    user_name: 'ユーザー名',
    email: 'メールアドレス',
    status: 'ステータス',
    start_date: '開始日',
    user_type: 'ユーザー区分',
    is_send_invoice_mail: '請求書メール送信',
    is_send_report_mail: 'レポート送信',
  },
  radio: {
    neccessary: '要',
    unneccessary: '不要',
  },
  checkbox: {
    send_invoice_mail: '送信する',
    not_send_invoice_mail: '送信しない',
    send_report_mail: '送信する',
    not_send_report_mail: '送信しない',
  },
  modal: {
    delete: {
      message: 'こちらのユーザーを削除してもよろしいですか。',
    },
  },
  user_types: {
    1: 'システム管理者（GS）',
    2: '企業管理者',
    3: '本部管理者',
    4: '店舗管理者',
    5: '一般ユーザー',
    6: '4G端末',
  },
  user_status: {
    active: '有効',
    inactive: '休止',
  },
  form_import: {
    title: 'インポートファイルを選択 (CSV)',
    confirm: 'ユーザデータをアップロードします。よろしいですか。',
    success: 'インポートが完了しました。',
  },
};
